import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/quickModeOrgUserRegisterLogFile';

/**
 * ログファイルのState型
 */
export interface ISearchLogFileState {
	readonly searchLogFile: string;
}

/**
 * 組織ユーザリストのState初期値
 */
const initialState: ISearchLogFileState = {
	searchLogFile: '',
};
/**
 * QuickMode登録・更新画面ログファイル用
 * @param state State
 * @param action アクション
 */
const quickModeOrgUserRegisterLogFileObj = (
	state: ISearchLogFileState,
	action: Action
) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setLogFile)) {
		return {
			...state,
			searchLogFile: action.payload.data,
		};
	}
	return state;
};

export default quickModeOrgUserRegisterLogFileObj;



// WEBPACK FOOTER //
// ./src/reducers/quickModeOrgUserRegisterLogFileObj.ts